import currentExecutingScript from 'current-executing-script';

// set the public path to be the path of the main entry script
__webpack_public_path__ = // eslint-disable-line
  currentExecutingScript()
    .src.split('?')[0]
    .split('/')
    .slice(0, -1)
    .join('/') + '/';


// polyfills
import 'nodelist-foreach-polyfill';
import './modules/polyfills';

// setup api
import '@/api';

import Vue from 'vue';
import store from './vuex/store';
import router from './vue/router';
import { sync } from 'vuex-router-sync';

import './vue/filters';


// Vue components
import FilterIndex from './vue/components/FilterIndex.vue'; // content filter vue component
import FilterIndexItem from './vue/components/FilterIndexItem.vue'; // content filter item vue component
import HolidaySearch from './vue/components/HolidaySearch.vue';
import Wishlist from './vue/components/Wishlist/Wishlist.vue';
import WishlistToggle from './vue/components/Wishlist/WishlistToggle.vue';
import AddOnList from './vue/components/Tour/AddOnList.vue';
import ExcursionList from './vue/components/Tour/ExcursionList.vue';
import Departures from './vue/components/Tour/Departures.vue';
import BrochureRequest from './vue/components/Brochure/BrochureRequest.vue';
import DataLayer from './vue/components/DataLayer.vue';
import ToursByPrice from './vue/components/ToursByPrice.vue';
import HolidaySearchModal from './vue/components/HolidaySearchModal.vue';
import SwiperCarousel from './vue/components/SwiperCarousel.vue';
import TourStyleIconsCarousel from './vue/components/Carousels/TourStyleIconsCarousel.vue';
import TourHotelCarousel from './vue/components/Carousels/TourHotelCarousel.vue';

// Checkout
import Checkout from '@/vue/components/Checkout/Checkout.vue';
import CheckoutAddon from '@/vue/components/Checkout/Steps/Addon.vue';
import CheckoutFlights from '@/vue/components/Checkout/Steps/Flights.vue';
import CheckoutTravellers from '@/vue/components/Checkout/Steps/Travellers.vue';
import CheckoutExcursions from '@/vue/components/Checkout/Steps/Excursions.vue';
import CheckoutPassengerDetails from '@/vue/components/Checkout/Steps/PassengerDetails.vue';
import CheckoutPayment from '@/vue/components/Checkout/Steps/Payment.vue';
import CheckoutBooking from '@/vue/components/Checkout/Steps/Booking.vue';

// Account
import Account from '@/vue/components/Account/Account.vue';

// Login
import Login from '@/vue/components/Login/Login.vue';
import Register from '@/vue/components/Login/Register.vue';
import ForgotPassword from '@/vue/components/Login/ForgotPassword.vue';
import ResetPassword from '@/vue/components/Login/ResetPassword.vue';


// Standard JS modules
import * as accordion from './modules/accordion';
import * as cookieBot from './modules/cookie-bot';
import * as carousel from './modules/carousel';
import * as helpers from './modules/helpers';
import * as siteNavigation from './modules/primary-nav';
import * as siteSearch from './modules/site-search';
import * as video from './modules/video';
import * as responsiveTable from './modules/responsive-table';
import * as scrollTop from './modules/scroll-top';
import * as activeState from './modules/active-state';
import * as cardCarousel from './modules/card-carousel';
import * as tourPage from './modules/tour-page';
import * as dropdownToggles from './modules/dropdown-toggles';
import * as readMoreToggle from './modules/readMoreToggle';

import gtm from './modules/gtm';
gtm.setupVuexSubscribe();

// focus top field when error occurs
import inputErrorFocus from './modules/inputErrorFocus';
inputErrorFocus(document.body);

$(function () {

  // Checkout vue
  const elCheckout = document.querySelector('checkout');
  if (elCheckout) {
    new Vue({
      el: elCheckout,
      store,
      components: {
        checkout: Checkout,
        'checkout-addon': CheckoutAddon,
        'checkout-flights': CheckoutFlights,
        'checkout-travellers': CheckoutTravellers,
        'checkout-excursions': CheckoutExcursions,
        'checkout-passenger-details': CheckoutPassengerDetails,
        'checkout-payment': CheckoutPayment,
        'checkout-booking': CheckoutBooking
      }
    });
  }

  // Account vue
  const elAccount = document.querySelector('account');
  if (elAccount) {
    import( /* webpackChunkName: "accountRouter" */ '@/vue/components/Account/accountRouter').then(accountRouter => {
      sync(store, accountRouter.default);

      new Vue({
        el: elAccount,
        store,
        router: accountRouter.default,
        components: {
          account: Account
        }
      });
    });
  }

  // Login vue
  const elLogin = document.querySelector('login');
  if (elLogin) {
    new Vue({
      el: elLogin,
      store,
      components: {
        login: Login
      }
    });
  }

  // Register vue
  const elRegister = document.querySelector('register');
  if (elRegister) {
    new Vue({
      el: elRegister,
      store,
      components: {
        register: Register
      }
    });
  }

  // Forgot password vue
  const elForgotPassword = document.querySelector('forgot-password');
  if (elForgotPassword) {
    new Vue({
      el: elForgotPassword,
      store,
      components: {
        'forgot-password': ForgotPassword
      }
    });
  }

  // Reset password vue
  const elResetPassword = document.querySelector('reset-password');
  if (elResetPassword) {
    new Vue({
      el: elResetPassword,
      store,
      components: {
        'reset-password': ResetPassword
      }
    });
  }

  // Setup vue for filter index page
  const elFilter = document.querySelector('filter-index');
  if (elFilter) {
    new Vue({
      el: elFilter,
      store,
      router,
      components: {
        'filter-index': FilterIndex,
        'filter-index-item': FilterIndexItem
      },
    });
  }

  // holiday search vue forms
  const elHolidaySearch = document.querySelectorAll('holiday-search');
  if (elHolidaySearch.length) {
    elHolidaySearch.forEach(el => {
      new Vue({
        el,
        store,
        components: {
          'holiday-search': HolidaySearch
        }
      })
    });
  }

  // holiday search vue forms
  const elHolidaySearchModal = document.querySelectorAll('holiday-search-modal');
  if (elHolidaySearchModal.length) {
    elHolidaySearchModal.forEach(el => {
      new Vue({
        el,
        store,
        components: {
          'holiday-search-modal': HolidaySearchModal
        }
      })
    });
  }

  // wishlist
  const elWishlist = document.querySelector('wishlist');
  if (elWishlist) {
    new Vue({
      el: elWishlist,
      router,
      components: {
        wishlist: Wishlist
      }
    });
  }

  // AddOns
  const elAddOnList = document.querySelectorAll('add-ons');
  if (elAddOnList.length) {
    elAddOnList.forEach(el => {
      new Vue({
        el,
        router,
        store,
        components: {
          'add-ons': AddOnList
        }
      })
    });
  }

  // Excursions
  const elExcursionList = document.querySelectorAll('excursions');
  if (elExcursionList.length) {
    elExcursionList.forEach(el => {
      new Vue({
        el,
        router,
        store,
        components: {
          'excursions': ExcursionList
        }
      })
    });
  }

  // <wishlist-toggle colour="pink" item="{}" wishlist-cookie-name="blah"></wishlist-toggle>
  const elWishlistToggle = document.querySelectorAll('wishlist-toggle');
  if (elWishlistToggle.length) {
    elWishlistToggle.forEach(el => {
      new Vue({
        el,
        components: {
          'wishlist-toggle': WishlistToggle
        }
      })
    });
  }

  // departures
  const elDepartures = document.querySelector('departures');
  if (elDepartures) {
    new Vue({
      el: elDepartures,
      router,
      components: {
        departures: Departures
      }
    });
  }

  // Order Brochure
  const elBrochureRequest = document.querySelectorAll('brochure-request');
  if (elBrochureRequest.length) {
    elBrochureRequest.forEach(el => {
      new Vue({
        el,
        router,
        store,
        components: {
          'brochure-request': BrochureRequest,
        }
      })
    });
  }

  // Data Layer 
  const elDataLayer = document.querySelectorAll('data-layer');
  if (elDataLayer.length) {
    elDataLayer.forEach(el => {
      new Vue({
        el,
        router,
        store,
        components: {
          'data-layer': DataLayer,
        }
      })
    });
  }
 
  const elToursByPrice = document.querySelector('tours-by-price');
  if (elToursByPrice) {
    new Vue({
      el: elToursByPrice,
      router,
      store,
      components: {
        'tours-by-price': ToursByPrice
      }
    });
  }

  // Swiper Carousel
  const elSwiperCarousel = document.querySelectorAll('swiper-carousel');
  if (elSwiperCarousel.length) {
    elSwiperCarousel.forEach(el => {
      new Vue({
        el,
        store,
        components: {
          'swiper-carousel': SwiperCarousel
        }
      })
    });
  }

  // Tour Style Icons Carousel
  const elTourStyleIconsCarousel = document.querySelectorAll('tour-style-icons-carousel');
  if (elTourStyleIconsCarousel.length) {
    elTourStyleIconsCarousel.forEach(el => {
      new Vue({
        el,
        store,
        components: {
          'tour-style-icons-carousel': TourStyleIconsCarousel
        }
      })
    });
  }

  // Tour Hotel Carousel
  const elTourHotelCarousel = document.querySelectorAll('tour-hotel-carousel');
  if (elTourHotelCarousel.length) {
    elTourHotelCarousel.forEach(el => {
      new Vue({
        el, 
        store,
        components: {
          'tour-hotel-carousel': TourHotelCarousel
        }
      })
    });
  }

  // Gallery Block
  $('.gallery-block-slider').slick({
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
    swipeToSlide: true,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  accordion.init();
  cookieBot.init();
  carousel.init();
  helpers.init();
  siteNavigation.init();
  siteSearch.init();
  video.init();
  responsiveTable.init();
  scrollTop.init();
  activeState.init();
  cardCarousel.init();
  tourPage.init();
  dropdownToggles.init();
  readMoreToggle.init();

  const changeTelephoneNumbers = () => {
    window.setTimeout(changeTelephoneNumbers, 3000);
    
    let telNumber = document.getElementById('tel').innerText;
    let desktopLink = document.getElementById('telLink');
    let mobileLink = document.getElementById('mobile-phone-icon');
    
    desktopLink.setAttribute('href', 'tel:'+ telNumber);
    mobileLink.setAttribute('href', 'tel:' + telNumber);
  };

  changeTelephoneNumbers();
});
